/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */

import React from 'react';
import { Accordion } from 'react-bootstrap';
import { DName, DInfoRects, DImageAndStatus, DKeyValueBody } from '../components/_lib/Details';
import Footer from '../components/footer/footer';
import { useSelector } from 'react-redux';
import { getFlattenedSoftware } from '../redux/selectors';
import DOMPurify from 'dompurify';
import Header from '../components/header/header';
import '../styles/softwareDetail.scss';
import { labels, DetailAccordionCard } from '@umati/dashboard-common';
import FrontendURLs from 'utilities/FrontendURLs';
import { useParams } from 'react-router-dom';

const SoftwareDetailView = () => {
  const params = useParams();
  const props = {
    sw: useSelector(state => getFlattenedSoftware(state, params.software)),
    fairTag: params.fair
  };

  console.log(params);
  console.log(props);

  const detailNameProps = {
    iconOnToggleTrue: props.sw?.logoUrl,
    iconOnToggleFalse: props.sw?.logoUrl,
    toggle: true,
    iconIsUrl: true,
    strong: props.sw?.manufacturer,
    title: props.sw?.name
  };

  const detailRectProps = props.sw
    ? [
        { label: labels.hall, value: props.sw?.Positions?.[props.fairTag]?.hall },
        { label: labels.booth, value: props.sw?.Positions?.[props.fairTag]?.booth }]
    : [];

  const overviewData = props.sw
    ? [
        { label: labels.name, value: props.sw.name },
        { label: labels.manufacturer, value: props.sw.Data.Manufacturer.text },
        { label: labels.homepage, value: props.sw.manufacturerShortURL, url: props.sw.manufacturerURL },
        { label: labels.location, value: props.sw._flatPositions },
        { label: labels.demopage, value: props.sw.demoPageShortUrl, url: props.sw.demoPageUrl }]
    : [];

  const anchor = props.sw?.name.replace(/\s+/g, '');
  const headerDetail = {
    text: props.sw?.name,
    link: FrontendURLs.getSoftware(props.sw?.SoftwareId, props.fairTag),
    anchor: anchor
  };

  return (
    props.sw &&
    <div>
      <Header {...props} fairTag={props.fairTag} detail={headerDetail} listType="software" containerClass="container-max" />
      <div className="view-sw-detail">
        <div className="hero">
          <div className="container-max">
            <DName {...detailNameProps} />
            <DInfoRects infos={detailRectProps} />
          </div>
        </div>{
        props.sw && <div className="container-max view-sw-detail">
          <DImageAndStatus imgUrl={props.sw.iconUrl} defaultImgUrl={props.sw.screenshotUrl}>
            <p></p>
          </DImageAndStatus>
          <div className="row justify-content-end">
            <div className="col-12 offset-lg-2 col-lg-9">
              <Accordion defaultActiveKey="0" className="mb-4">
                <DetailAccordionCard eventKey="0" title={labels.information}>
                  <DKeyValueBody data={overviewData} eventKey="0" />
                </DetailAccordionCard>
                <DetailAccordionCard eventKey="1" title={labels.details}>
                  <img className="content-img" src={props.sw.screenshotUrl}></img>
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.sw.description) }}></div>
                </DetailAccordionCard>
              </Accordion>
            </div>
            <div className="col-12 col-lg-1" />
          </div>
        </div>
        }
      </div>
      <div className="container-max">
        <Footer />
      </div>
    </div>
    || <></>
  );
};

export default SoftwareDetailView;
